/* eslint-disable no-unused-vars */
import React from 'react';
import * as S from './ExportTableModal.styled';
import { Checkbox, ParagraphWithTooltip } from 'components';
import { CheckTreeExportModalManageCampaigns } from 'assets/icons';

export const EventsSection = ({
  metrics,
  isAllMetricsSelected,
  onHandleMetrics,
  onHandleMetricsAll,
  events,
  isAllEventsSelected,
  onHandleEvents,
  onHandleEventsAll,
}) => {
  return (
    <S.SectionContainer>
      <S.SectionBox>
        <Checkbox
          label='Metrics'
          name='Metrics'
          isChecked={isAllMetricsSelected && metrics.some((el) => el.isSelected)}
          id='Metrics'
          isOpenGroup={isAllMetricsSelected && metrics.some((el) => !el.isSelected)}
          onChange={onHandleMetricsAll}
          style={{ marginLeft: '24px', marginBottom: '12px' }}
        />
        {metrics?.map(({ fieldName, title, isSelected }, index) => (
          <S.RowElement key={index}>
            <CheckTreeExportModalManageCampaigns />
            <Checkbox
              name={fieldName}
              isChecked={isSelected}
              id={fieldName}
              onChange={() => onHandleMetrics(fieldName)}
            />
            <S.ParagraphBox>
              <ParagraphWithTooltip text={title} />
            </S.ParagraphBox>
          </S.RowElement>
        ))}
        {events?.length > 0 && (
          <>
            <Checkbox
              label='Events'
              name='Events'
              isChecked={isAllEventsSelected && events.some((el) => el.isSelected)}
              id='Events'
              isOpenGroup={isAllEventsSelected && events.some((el) => !el.isSelected)}
              onChange={onHandleEventsAll}
              style={{ margin: '16px 0 12px 24px' }}
            />
            {events.map(({ fieldName, title, isSelected }, index) => (
              <S.RowElement key={index}>
                <CheckTreeExportModalManageCampaigns />
                <Checkbox
                  name={fieldName}
                  isChecked={isSelected}
                  id={fieldName}
                  onChange={() => onHandleEvents(fieldName)}
                />
                <S.ParagraphBox>
                  <ParagraphWithTooltip text={title} />
                </S.ParagraphBox>
              </S.RowElement>
            ))}
          </>
        )}
      </S.SectionBox>
    </S.SectionContainer>
  );
};
